import t from "react";
import { c as d, t as f } from "./app-a75c1d35.mjs";
import { L as u } from "./Link-479ac100.mjs";
import { I as x, W as C } from "./Icon-3122c134.mjs";
const b = "chips", k = "chips--compact", E = "chips--bolder", I = "close-icon", o = {
  chips: b,
  chipsCompact: k,
  chipsBolder: E,
  closeIcon: I
}, i = 40;
function _(e) {
  const {
    text: c = "",
    variant: l = "standard",
    bolder: r = !1,
    clipLongText: h = !0,
    selected: s,
    showXWhenSelected: m = !1
  } = e, p = c.length > i, n = /* @__PURE__ */ t.createElement(t.Fragment, null, p && h ? `${c.slice(0, i).trim()}...` : c, m && s && /* @__PURE__ */ t.createElement(x, { icon: C.CLOSE, className: o.closeIcon })), a = d(
    e.className,
    r ? o.chipsBolder : f.textsBodyText,
    o.chips,
    l === "compact" && o.chipsCompact
  );
  return e.as === "button" ? /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: a,
      onClick: e.onClick,
      "aria-checked": !!s,
      role: "checkbox",
      title: c
    },
    n
  ) : /* @__PURE__ */ t.createElement(
    u,
    {
      title: c,
      href: e.href || "#",
      disableLinkTextStyle: !0,
      "aria-checked": !!s,
      role: "checkbox",
      className: a
    },
    n
  );
}
export {
  _ as C
};
//# sourceMappingURL=Chips-2709174d.mjs.map
